
function SendIcon(props) {
    return (
        <svg stroke="none" width="1em" height="1em" viewBox="0 0 16.045 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M17.633,9.293,3.284,2.079a.849.849,0,0,0-1.2,1.042l2,5.371,9.138,1.523L4.086,11.538l-2,5.371a.812.812,0,0,0,1.2.962l14.349-7.214A.762.762,0,0,0,17.633,9.293Z" transform="translate(-2.009 -1.994)" fill="currentColor" />
        </svg>
    );
}

export {SendIcon}